import { useSession } from 'next-auth/react';
import { useEffect, useMemo, useState } from 'react';

import { fetchProductsAndConf, getFaiProductsFromSapic, mergeCeAndSapicData } from '@services/products.service';

import { ContentEditorItem } from '@app-types/cms';
import { FaiProduct } from '@app-types/fai';
import { PlanType } from '@app-types/product';

export function useGetOffersConnected(
    initialProducts: PlanType[],
    initialFaiProducts: FaiProduct[],
    rocs: ContentEditorItem[],
    faiOrder: string[],
) {
    const session = useSession();

    const [faiProducts, setFaiProducts] = useState<FaiProduct[]>(initialFaiProducts);
    const [products, setProducts] = useState(initialProducts);
    const [isLoading, setIsLoading] = useState(false);

    const memoizedRocs = useMemo(() => rocs, [JSON.stringify(rocs)]);
    const memoizedFaiOrder = useMemo(() => faiOrder, [JSON.stringify(faiOrder)]);

    useEffect(() => {
        if (!session.data || !memoizedFaiOrder || !memoizedRocs) {
            return;
        }

        async function fetchData() {
            setIsLoading(true);
            const faiOfferApi = await getFaiProductsFromSapic(session.data);
            const faiProductsClient = mergeCeAndSapicData(memoizedRocs, faiOfferApi, memoizedFaiOrder);
            setFaiProducts(faiProductsClient);
            const productsClient = await fetchProductsAndConf(faiProductsClient, session.data);
            setProducts(productsClient.plans);
            setIsLoading(false);
        }

        fetchData();
    }, [session.data?.user, memoizedRocs, memoizedFaiOrder]);

    return {
        products,
        faiProducts,
        isLoading,
    };
}
